"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TEXT_SEMI_BOLD = exports.TEXT_BOLD = exports.TAB_GROUP_HEADING = exports.TABS_OVERFLOW_WRAPPER = exports.TABLE_WRAPPER = exports.TABLE_SELECTED_ROW = exports.TABLE_SCROLL_START = exports.TABLE_SCROLL_SCROLLING = exports.TABLE_SCROLL_NONE = exports.TABLE_SCROLL_END = exports.TABLE_ROW = exports.TABLE_HEADER = exports.TABLE_EXPANDED_ROW_CONTENT = exports.TABLE_EXPANDED_ROW = exports.TABLE_DRAWER_VISIBILLITY_SETTINGS = exports.TABLE_DRAWER_SORTABLE_CARD = exports.TABLE_DRAWER_EXTRA_CONTENT = exports.TABLE_DENSITY = exports.TABLE_CONTROLS_SEARCH_WRAPPER = exports.TABLE_CONTROLS_RIGHT = exports.TABLE_CONTROLS_LEFT = exports.TABLE_CONTROLS_INPUT_CONTAINER = exports.TABLE_CONTROLS_BAR = exports.TABLE_CONTAINER = exports.TABLE_CELL_CONTENT = exports.TABLE_CELL = exports.TABLE = exports.SUPERHEADING2 = exports.SUPERHEADING1 = exports.SUBHEADING2 = exports.SUBHEADING1 = exports.SMALLISH = exports.SMALLER = exports.SKELETON = exports.SIDEBAR_NAV_SECONDARY_ITEM = exports.SIDEBAR_NAV_PRIMARY_ITEM_TITLE = exports.SIDEBAR_NAV_PRIMARY_ITEM_CHILDREN = exports.SIDEBAR_NAV_PRIMARY_ITEM = exports.SIDEBAR_NAV_HEADER = exports.SIDEBAR_NAV = exports.SELECT_BUTTON_TEXT = exports.SELECT_BUTTON = exports.SEGMENTED_CONTROL = exports.SCORECARD_SELECT_ITEM = exports.SCORECARD_SELECT = exports.RATING_SELECT_ITEM = exports.RATING_SELECT = exports.PROGRESS_TRACKER_ITEM_CONTENT = exports.PROGRESS_TRACKER_ITEM = exports.PROGRESS_TRACKER = exports.PAGINATION_PAGES_MENU = exports.PAGINATION_NAV = exports.PAGINATION_INFO = exports.PAGINATION_BUTTON_DISABLED = exports.PAGINATION_BUTTON = exports.PAGINATION = exports.OVERFLOWED = exports.OUTLINE = exports.NUMERIC_BUTTON = exports.MUTED = exports.MENU_TRIGGER = exports.LIST_TABULAR = exports.LINK_BUTTON = exports.LINK = exports.LEGEND = exports.LEAD = exports.INLINE_DRAWER_OPEN = exports.INLINE_DRAWER_CONTAINER = exports.INLINE_DRAWER_ASSOCIATED_CONTENT = exports.INLINE_DRAWER = exports.ICON_CUSTOM = exports.ICON_BUTTON = exports.FORM_FEEDBACK_TEXT = exports.FORCE_HOVER = exports.FORCE_FOCUS = exports.FIXED_TEXT = exports.FIELDSET = exports.DRAWER_CLOSE_BUTTON = exports.DIALOG_DESCRIPTION = exports.CONTROL_SELECT_CARD_CONTROL = exports.CONTROL_SELECT_CARD = exports.CONTROL_SELECT = exports.CONTROL_LABEL = exports.CONTROL_FILL = exports.CONSTRAINED = exports.CONDENSED = exports.CARD_INNER = exports.CAPTION = exports.BODY_TEXT = exports.BASE_FROW_CLASS = exports.BASE_FLEX_ITEM_CLASS = exports.BASE_COL_CLASS = exports.AVATAR = exports.ACTION_BAR_WRAPPER = exports.ACTION_BAR_TEXT = exports.ACTION_BAR_OVERFLOW_BUTTON = exports.ACTION_BAR_ITEM = exports.ACTION_BAR = exports.ACCORDION_TRIGGER = exports.ACCORDION = void 0;
exports.TRUNCATED = void 0;
exports.buttonStyleClass = buttonStyleClass;
exports.cardLevelClass = cardLevelClass;
exports.colorFamilyClass = colorFamilyClass;
exports.discreteRatingClass = discreteRatingClass;
exports.horizontalPositionClass = horizontalPositionClass;
exports.paddingLevelClass = paddingLevelClass;
exports.sizeClass = sizeClass;
var NS = undefined || undefined || 'bp3';

// modifiers
var CONDENSED = "".concat(NS, "-condensed");
exports.CONDENSED = CONDENSED;
var CONSTRAINED = "".concat(NS, "-constrained");
exports.CONSTRAINED = CONSTRAINED;
var FORCE_FOCUS = "".concat(NS, "-force-focus");
exports.FORCE_FOCUS = FORCE_FOCUS;
var FORCE_HOVER = "".concat(NS, "-force-hover");
exports.FORCE_HOVER = FORCE_HOVER;
var MUTED = "".concat(NS, "-muted");
exports.MUTED = MUTED;
var OUTLINE = "".concat(NS, "-outline");
exports.OUTLINE = OUTLINE;
var OVERFLOWED = "".concat(NS, "-overflowed");
exports.OVERFLOWED = OVERFLOWED;
var SMALLER = "".concat(NS, "-smaller");
exports.SMALLER = SMALLER;
var SMALLISH = "".concat(NS, "-smallish");
exports.SMALLISH = SMALLISH;
var TRUNCATED = "".concat(NS, "-truncated");

// text utilities
exports.TRUNCATED = TRUNCATED;
var TEXT_SEMI_BOLD = "".concat(NS, "-text-semi-bold");
exports.TEXT_SEMI_BOLD = TEXT_SEMI_BOLD;
var TEXT_BOLD = "".concat(NS, "-text-bold");

// textual elements
exports.TEXT_BOLD = TEXT_BOLD;
var BODY_TEXT = "".concat(NS, "-body-text");
exports.BODY_TEXT = BODY_TEXT;
var CAPTION = "".concat(NS, "-caption");
exports.CAPTION = CAPTION;
var LEAD = "".concat(NS, "-lead");
exports.LEAD = LEAD;
var SUBHEADING1 = "".concat(NS, "-sub-heading-1");
exports.SUBHEADING1 = SUBHEADING1;
var SUBHEADING2 = "".concat(NS, "-sub-heading-2");
exports.SUBHEADING2 = SUBHEADING2;
var SUPERHEADING1 = "".concat(NS, "-super-heading-1");
exports.SUPERHEADING1 = SUPERHEADING1;
var SUPERHEADING2 = "".concat(NS, "-super-heading-2");

// components
exports.SUPERHEADING2 = SUPERHEADING2;
var ACCORDION = "".concat(NS, "-accordion");
exports.ACCORDION = ACCORDION;
var ACCORDION_TRIGGER = "".concat(NS, "-accordion-trigger");
exports.ACCORDION_TRIGGER = ACCORDION_TRIGGER;
var ACTION_BAR = "".concat(NS, "-action-bar");
exports.ACTION_BAR = ACTION_BAR;
var ACTION_BAR_ITEM = "".concat(NS, "-action-bar-item");
exports.ACTION_BAR_ITEM = ACTION_BAR_ITEM;
var ACTION_BAR_OVERFLOW_BUTTON = "".concat(NS, "-action-bar-overflow-button");
exports.ACTION_BAR_OVERFLOW_BUTTON = ACTION_BAR_OVERFLOW_BUTTON;
var ACTION_BAR_TEXT = "".concat(NS, "-action-bar-text");
exports.ACTION_BAR_TEXT = ACTION_BAR_TEXT;
var ACTION_BAR_WRAPPER = "".concat(NS, "-action-bar-wrapper");
exports.ACTION_BAR_WRAPPER = ACTION_BAR_WRAPPER;
var AVATAR = "".concat(NS, "-avatar");
exports.AVATAR = AVATAR;
var CARD_INNER = "".concat(NS, "-card-inner");
exports.CARD_INNER = CARD_INNER;
var CONTROL_FILL = "".concat(NS, "-control-fill");
exports.CONTROL_FILL = CONTROL_FILL;
var CONTROL_LABEL = "".concat(NS, "-control-label");
exports.CONTROL_LABEL = CONTROL_LABEL;
var CONTROL_SELECT = "".concat(NS, "-control-select");
exports.CONTROL_SELECT = CONTROL_SELECT;
var CONTROL_SELECT_CARD = "".concat(NS, "-control-select-card");
exports.CONTROL_SELECT_CARD = CONTROL_SELECT_CARD;
var CONTROL_SELECT_CARD_CONTROL = "".concat(NS, "-control-select-card-control");
exports.CONTROL_SELECT_CARD_CONTROL = CONTROL_SELECT_CARD_CONTROL;
var DIALOG_DESCRIPTION = "".concat(NS, "-dialog-description");
exports.DIALOG_DESCRIPTION = DIALOG_DESCRIPTION;
var DRAWER_CLOSE_BUTTON = "".concat(NS, "-drawer-close-button");
exports.DRAWER_CLOSE_BUTTON = DRAWER_CLOSE_BUTTON;
var FIELDSET = "".concat(NS, "-fieldset");
exports.FIELDSET = FIELDSET;
var FIXED_TEXT = "".concat(NS, "-fixed-text");
exports.FIXED_TEXT = FIXED_TEXT;
var FORM_FEEDBACK_TEXT = "".concat(NS, "-form-feedback-text");
exports.FORM_FEEDBACK_TEXT = FORM_FEEDBACK_TEXT;
var ICON_BUTTON = "".concat(NS, "-icon-button");
exports.ICON_BUTTON = ICON_BUTTON;
var ICON_CUSTOM = "".concat(NS, "-icon-custom");
exports.ICON_CUSTOM = ICON_CUSTOM;
var INLINE_DRAWER = "".concat(NS, "-inline-drawer");
exports.INLINE_DRAWER = INLINE_DRAWER;
var INLINE_DRAWER_CONTAINER = "".concat(NS, "-inline-drawer-container");
exports.INLINE_DRAWER_CONTAINER = INLINE_DRAWER_CONTAINER;
var INLINE_DRAWER_OPEN = "".concat(NS, "-inline-drawer-open");
exports.INLINE_DRAWER_OPEN = INLINE_DRAWER_OPEN;
var INLINE_DRAWER_ASSOCIATED_CONTENT = "".concat(NS, "-inline-drawer-associated-content");
exports.INLINE_DRAWER_ASSOCIATED_CONTENT = INLINE_DRAWER_ASSOCIATED_CONTENT;
var LEGEND = "".concat(NS, "-legend");
exports.LEGEND = LEGEND;
var LINK = "".concat(NS, "-link");
exports.LINK = LINK;
var LINK_BUTTON = "".concat(NS, "-link-button");
exports.LINK_BUTTON = LINK_BUTTON;
var LIST_TABULAR = "".concat(NS, "-list-tabular");
exports.LIST_TABULAR = LIST_TABULAR;
var MENU_TRIGGER = "".concat(NS, "-menu-trigger");
exports.MENU_TRIGGER = MENU_TRIGGER;
var NUMERIC_BUTTON = "".concat(NS, "-numeric-button");
exports.NUMERIC_BUTTON = NUMERIC_BUTTON;
var PAGINATION = "".concat(NS, "-pagination");
exports.PAGINATION = PAGINATION;
var PAGINATION_BUTTON = "".concat(NS, "-pagination-button");
exports.PAGINATION_BUTTON = PAGINATION_BUTTON;
var PAGINATION_BUTTON_DISABLED = "".concat(NS, "-pagination-button-disabled");
exports.PAGINATION_BUTTON_DISABLED = PAGINATION_BUTTON_DISABLED;
var PAGINATION_INFO = "".concat(NS, "-pagination-info");
exports.PAGINATION_INFO = PAGINATION_INFO;
var PAGINATION_NAV = "".concat(NS, "-pagination-nav");
exports.PAGINATION_NAV = PAGINATION_NAV;
var PAGINATION_PAGES_MENU = "".concat(NS, "-pagination-pages-menu");
exports.PAGINATION_PAGES_MENU = PAGINATION_PAGES_MENU;
var PROGRESS_TRACKER = "".concat(NS, "-progress-tracker");
exports.PROGRESS_TRACKER = PROGRESS_TRACKER;
var PROGRESS_TRACKER_ITEM = "".concat(NS, "-progress-tracker-item");
exports.PROGRESS_TRACKER_ITEM = PROGRESS_TRACKER_ITEM;
var PROGRESS_TRACKER_ITEM_CONTENT = "".concat(NS, "-progress-tracker-item-content");
exports.PROGRESS_TRACKER_ITEM_CONTENT = PROGRESS_TRACKER_ITEM_CONTENT;
var RATING_SELECT = "".concat(NS, "-rating-select");
exports.RATING_SELECT = RATING_SELECT;
var RATING_SELECT_ITEM = "".concat(NS, "-rating-select-item");
exports.RATING_SELECT_ITEM = RATING_SELECT_ITEM;
var SCORECARD_SELECT = "".concat(NS, "-scorecard-select");
exports.SCORECARD_SELECT = SCORECARD_SELECT;
var SCORECARD_SELECT_ITEM = "".concat(NS, "-scorecard-select-item");
exports.SCORECARD_SELECT_ITEM = SCORECARD_SELECT_ITEM;
var SEGMENTED_CONTROL = "".concat(NS, "-segmented-control");
exports.SEGMENTED_CONTROL = SEGMENTED_CONTROL;
var SELECT_BUTTON = "".concat(NS, "-select-button");
exports.SELECT_BUTTON = SELECT_BUTTON;
var SELECT_BUTTON_TEXT = "".concat(NS, "-select-button-text");
exports.SELECT_BUTTON_TEXT = SELECT_BUTTON_TEXT;
var SIDEBAR_NAV = "".concat(NS, "-sidebar-nav");
exports.SIDEBAR_NAV = SIDEBAR_NAV;
var SIDEBAR_NAV_HEADER = "".concat(NS, "-sidebar-nav-header");
exports.SIDEBAR_NAV_HEADER = SIDEBAR_NAV_HEADER;
var SIDEBAR_NAV_PRIMARY_ITEM = "".concat(NS, "-sidebar-nav-primary-item");
exports.SIDEBAR_NAV_PRIMARY_ITEM = SIDEBAR_NAV_PRIMARY_ITEM;
var SIDEBAR_NAV_PRIMARY_ITEM_CHILDREN = "".concat(NS, "-sidebar-nav-primary-item-children");
exports.SIDEBAR_NAV_PRIMARY_ITEM_CHILDREN = SIDEBAR_NAV_PRIMARY_ITEM_CHILDREN;
var SIDEBAR_NAV_PRIMARY_ITEM_TITLE = "".concat(NS, "-sidebar-nav-primary-item-title");
exports.SIDEBAR_NAV_PRIMARY_ITEM_TITLE = SIDEBAR_NAV_PRIMARY_ITEM_TITLE;
var SIDEBAR_NAV_SECONDARY_ITEM = "".concat(NS, "-sidebar-nav-secondary-item");
exports.SIDEBAR_NAV_SECONDARY_ITEM = SIDEBAR_NAV_SECONDARY_ITEM;
var SKELETON = "".concat(NS, "-skeleton");
exports.SKELETON = SKELETON;
var TABLE = "".concat(NS, "-table");
exports.TABLE = TABLE;
var TABLE_CELL = "".concat(NS, "-table-cell");
exports.TABLE_CELL = TABLE_CELL;
var TABLE_CELL_CONTENT = "".concat(NS, "-table-cell-content");
exports.TABLE_CELL_CONTENT = TABLE_CELL_CONTENT;
var TABLE_CONTAINER = "".concat(NS, "-table-container");
exports.TABLE_CONTAINER = TABLE_CONTAINER;
var TABLE_CONTROLS_BAR = "".concat(NS, "-table-controls-bar");
exports.TABLE_CONTROLS_BAR = TABLE_CONTROLS_BAR;
var TABLE_CONTROLS_INPUT_CONTAINER = "".concat(NS, "-table-controls-input-container");
exports.TABLE_CONTROLS_INPUT_CONTAINER = TABLE_CONTROLS_INPUT_CONTAINER;
var TABLE_CONTROLS_LEFT = "".concat(NS, "-table-controls-left");
exports.TABLE_CONTROLS_LEFT = TABLE_CONTROLS_LEFT;
var TABLE_CONTROLS_RIGHT = "".concat(NS, "-table-controls-right");
exports.TABLE_CONTROLS_RIGHT = TABLE_CONTROLS_RIGHT;
var TABLE_CONTROLS_SEARCH_WRAPPER = "".concat(NS, "-table-controls-search-wrapper");
exports.TABLE_CONTROLS_SEARCH_WRAPPER = TABLE_CONTROLS_SEARCH_WRAPPER;
var TABLE_DENSITY = "".concat(NS, "-table-density");
exports.TABLE_DENSITY = TABLE_DENSITY;
var TABLE_DRAWER_EXTRA_CONTENT = "".concat(NS, "-table-drawer-extra-content");
exports.TABLE_DRAWER_EXTRA_CONTENT = TABLE_DRAWER_EXTRA_CONTENT;
var TABLE_DRAWER_SORTABLE_CARD = "".concat(NS, "-table-drawer-sortable-card");
exports.TABLE_DRAWER_SORTABLE_CARD = TABLE_DRAWER_SORTABLE_CARD;
var TABLE_DRAWER_VISIBILLITY_SETTINGS = "".concat(NS, "-table-drawer-visibility-settings");
exports.TABLE_DRAWER_VISIBILLITY_SETTINGS = TABLE_DRAWER_VISIBILLITY_SETTINGS;
var TABLE_EXPANDED_ROW = "".concat(NS, "-table-expanded-row");
exports.TABLE_EXPANDED_ROW = TABLE_EXPANDED_ROW;
var TABLE_EXPANDED_ROW_CONTENT = "".concat(NS, "-table-expanded-row-content");
exports.TABLE_EXPANDED_ROW_CONTENT = TABLE_EXPANDED_ROW_CONTENT;
var TABLE_HEADER = "".concat(NS, "-table-header");
exports.TABLE_HEADER = TABLE_HEADER;
var TABLE_ROW = "".concat(NS, "-table-row");
exports.TABLE_ROW = TABLE_ROW;
var TABLE_SCROLL_END = "".concat(NS, "-table-scroll-end");
exports.TABLE_SCROLL_END = TABLE_SCROLL_END;
var TABLE_SCROLL_NONE = "".concat(NS, "-table-scroll-none");
exports.TABLE_SCROLL_NONE = TABLE_SCROLL_NONE;
var TABLE_SCROLL_SCROLLING = "".concat(NS, "-table-scroll-scrolling");
exports.TABLE_SCROLL_SCROLLING = TABLE_SCROLL_SCROLLING;
var TABLE_SCROLL_START = "".concat(NS, "-table-scroll-start");
exports.TABLE_SCROLL_START = TABLE_SCROLL_START;
var TABLE_SELECTED_ROW = "".concat(NS, "-table-selected-row");
exports.TABLE_SELECTED_ROW = TABLE_SELECTED_ROW;
var TABLE_WRAPPER = "".concat(NS, "-table-wrapper");
exports.TABLE_WRAPPER = TABLE_WRAPPER;
var TAB_GROUP_HEADING = "".concat(NS, "-tab-group-heading");
exports.TAB_GROUP_HEADING = TAB_GROUP_HEADING;
var TABS_OVERFLOW_WRAPPER = "".concat(NS, "-tabs-overflow-wrapper");

// Layout
exports.TABS_OVERFLOW_WRAPPER = TABS_OVERFLOW_WRAPPER;
var BASE_COL_CLASS = "".concat(NS, "-col");
exports.BASE_COL_CLASS = BASE_COL_CLASS;
var BASE_FROW_CLASS = "".concat(NS, "-frow");
exports.BASE_FROW_CLASS = BASE_FROW_CLASS;
var BASE_FLEX_ITEM_CLASS = "".concat(NS, "-flex-item");
exports.BASE_FLEX_ITEM_CLASS = BASE_FLEX_ITEM_CLASS;
function cardLevelClass(cardLevel) {
  if (cardLevel == null) {
    return undefined;
  }
  return "".concat(NS, "-level-").concat(cardLevel);
}
function colorFamilyClass(colorFamily) {
  if (colorFamily === null || colorFamily === undefined) {
    return undefined;
  }
  return "".concat(NS, "-color-family-").concat(colorFamily);
}
function discreteRatingClass(discreteRating) {
  if (discreteRating == null) {
    return undefined;
  }
  return "".concat(NS, "-discrete-rating-").concat(discreteRating);
}
function paddingLevelClass(paddingLevel) {
  if (paddingLevel == null) {
    return undefined;
  }
  return "".concat(NS, "-padding-level-").concat(paddingLevel);
}
function sizeClass(size) {
  if (size == null) {
    return undefined;
  }
  return "".concat(NS, "-size-").concat(size);
}
function buttonStyleClass(buttonStyle) {
  if (buttonStyle == null) {
    return undefined;
  }
  return "".concat(NS, "-button-style-").concat(buttonStyle);
}

/**
 * There is already a Blueprint `positionClass` function but we need a different method
 * to only allow horizontal positions as arguments
 */
function horizontalPositionClass(position) {
  if (position == null) {
    return undefined;
  }
  return "".concat(NS, "-position-").concat(position);
}